import{defineMessages}from'react-intl';

export default defineMessages({
label_other:{
id:'tiled_radio_button_group.label_other',
defaultMessage:'OTHER'},

placeholder_other:{
id:'tiled_radio_button_group.placeholder_other',
defaultMessage:'Enter Other Value'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1RpbGVkUmFkaW9CdXR0b25Hcm91cC9UaWxlZFJhZGlvQnV0dG9uR3JvdXAubWVzc2FnZXMuanMiXSwibmFtZXMiOlsiZGVmaW5lTWVzc2FnZXMiLCJsYWJlbF9vdGhlciIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiLCJwbGFjZWhvbGRlcl9vdGhlciJdLCJtYXBwaW5ncyI6IkFBQUEsT0FBU0EsY0FBVCxLQUErQixZQUEvQjs7QUFFQSxjQUFlQSxnQkFBZTtBQUM1QkMsWUFBYTtBQUNYQyxHQUFJLHNDQURPO0FBRVhDLGVBQWdCLE9BRkwsQ0FEZTs7QUFLNUJDLGtCQUFtQjtBQUNqQkYsR0FBSSw0Q0FEYTtBQUVqQkMsZUFBZ0IsbUJBRkMsQ0FMUyxDQUFmLENBQWYiLCJmaWxlIjoiVGlsZWRSYWRpb0J1dHRvbkdyb3VwLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIGxhYmVsX290aGVyOiB7XG4gICAgaWQ6ICd0aWxlZF9yYWRpb19idXR0b25fZ3JvdXAubGFiZWxfb3RoZXInLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnT1RIRVInLFxuICB9LFxuICBwbGFjZWhvbGRlcl9vdGhlcjoge1xuICAgIGlkOiAndGlsZWRfcmFkaW9fYnV0dG9uX2dyb3VwLnBsYWNlaG9sZGVyX290aGVyJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0VudGVyIE90aGVyIFZhbHVlJyxcbiAgfSxcbn0pO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/components/TiledRadioButtonGroup/TiledRadioButtonGroup.messages.js
// module id = 2044
// module chunks = 0